// FAQ content for the app, mirroring the published content on
// https://emdrlink.pl/app/#faq (Polish source of truth).
export interface FaqItem {
    q: string;
    a: string[]; // paragraphs; lines starting with "– " render as list items
}

export const FAQ_INTRO = "Pytania i odpowiedzi dotyczące aplikacji EMDR Online";

export const FAQ_ITEMS: FaqItem[] = [
    {
        q: "Czym jest Aplikacja EMDR Online?",
        a: ["EMDR Online to działający w przeglądarce program wspierający prowadzenie sesji EMDR na odległość. Terapeuta może utworzyć sesję indywidualną lub grupową (obecnie opcja grupowa jest jeszcze niedostępna), zaprosić do niej pacjenta oraz prowadzić stymulację bilateralną w środowisku przygotowanym do pracy terapeutycznej online."],
    },
    {
        q: "Dla kogo przeznaczona jest aplikacja?",
        a: ["Aplikacja EMDR Online została przygotowana dla terapeutów prowadzących sesje EMDR oraz ich pacjentów. Terapeuta tworzy sesję i udostępnia zaproszenie, natomiast pacjent dołącza za pomocą otrzymanego linku."],
    },
    {
        q: "Jak rozpocząć korzystanie z EMDR Online?",
        a: ["Terapeuta powinien wejść na app.emdrlink.pl, utworzyć konto lub zalogować się do programu, a następnie przygotować sesję dla pacjenta. Po jej utworzeniu można wysłać pacjentowi link za pomocą wiadomości e-mail lub wybranego komunikatora."],
    },
    {
        q: "Jak klient (pacjent) dołącza do sesji?",
        a: ["Klient (pacjent) otwiera link otrzymany od terapeuty i postępuje zgodnie z instrukcjami wyświetlanymi na ekranie. Cały proces odbywa się w przeglądarce internetowej, dlatego nie trzeba pobierać ani instalować osobnego programu."],
    },
    {
        q: "Czy trzeba instalować aplikację?",
        a: ["Nie. Nasza aplikacja EMDR Online działa przez przeglądarkę internetową. Dzięki temu program można uruchomić bez pobierania dodatkowego oprogramowania i bez przechodzenia przez skomplikowaną konfigurację."],
    },
    {
        q: "Na jakich urządzeniach działa EMDR Online?",
        a: ["Z aplikacji można korzystać na komputerach oraz urządzeniach mobilnych wyposażonych w przeglądarkę internetową. Dla zapewnienia komfortu podczas stymulacji wzrokowej warto wybrać urządzenie z odpowiednio dużym ekranem i ustawić je stabilnie na wysokości wzroku (jednak nie jest to niezbędne)."],
    },
    {
        q: "Jak przygotować się do sesji online?",
        a: [
            "Przed rozpoczęciem sesji warto:",
            "– sprawdzić połączenie z internetem,",
            "– naładować urządzenie lub podłączyć je do zasilania,",
            "– zamknąć niepotrzebne programy i karty przeglądarki,",
            "– wyłączyć powiadomienia, które mogłyby przeszkadzać,",
            "– ustawić ekran w wygodnej pozycji,",
            "– zadbać o spokojne i prywatne miejsce.",
            "Szczegółowe zasady przygotowania do pracy terapeutycznej ustala terapeuta.",
        ],
    },
    {
        q: "Czy EMDR Online umożliwia prowadzenie sesji indywidualnych?",
        a: ["Tak. Terapeuta może utworzyć sesję dla konkretnego pacjenta, a następnie przekazać mu indywidualny link umożliwiający dołączenie do spotkania."],
    },
    {
        q: "Czy w EMDR Online można prowadzić sesje grupowe?",
        a: ["Jeszcze nie. Jest to możliwość, która zostanie dodana w kolejnej iteracji naszej aplikacji."],
    },
    {
        q: "Czy EMDRlink Online ma bazę pacjentów?",
        a: ["Tak. Terapeuta może korzystać z edytowalnej bazy pacjentów, która ułatwia organizowanie pracy oraz przygotowywanie kolejnych sesji."],
    },
    {
        q: "Jaką formę stymulacji bilateralnej zapewnia EMDR Online?",
        a: [
            "EMDR Online umożliwia prowadzenie stymulacji wzrokowej na ekranie urządzenia pacjenta. Program został zaprojektowany tak, aby wspierać terapeutę w prowadzeniu zdalnych sesji EMDR i ograniczyć liczbę czynności technicznych wymaganych od pacjenta.",
            "Integracja programu z Neuro Tapperem EMDRlink rozszerza możliwości terapii EMDR o stymulację dotykową (opcja ta będzie uruchomiona przy kolejnej iteracji programu).",
        ],
    },
    {
        q: "Czy podczas korzystania z aplikacji potrzebny jest Neuro Tapper EMDRlink?",
        a: ["Nie. Jest to opcja która zwiększa efektywność terapii oraz jest bardzo dobrym jej rozszerzeniem, jednak nie jest wymagany do prawidłowego funkcjonowania. Z aplikacji EMDR Online można korzystać bez fizycznego Tappera. Podstawą pracy w aplikacji jest stymulacja wzrokowa wyświetlana na ekranie."],
    },
    {
        q: "Czy EMDRlink Online może być używany samodzielnie przez pacjenta?",
        a: [
            "EMDR Online jest przeznaczony do sesji tworzonych i prowadzonych przez terapeutę. Pacjent dołącza do spotkania za pomocą otrzymanego linku i korzysta z aplikacji zgodnie ze wskazówkami osoby prowadzącej.",
            "EMDR Online nie jest samodzielną terapią ani zamiennikiem kontaktu ze specjalistą.",
        ],
    },
    {
        q: "Czy pacjent może znaleźć terapeutę przez portal EMDRlink?",
        a: ["Tak. W ekosystemie EMDRlink dostępna jest wyszukiwarka specjalistów, która pomaga znaleźć terapeutę pracującego metodą EMDR. Po wybraniu specjalisty należy skontaktować się z nim bezpośrednio i ustalić możliwość rozpoczęcia terapii."],
    },
    {
        q: "Czy korzystanie z EMDR Online jest płatne?",
        a: ["Nie. Zgodnie z aktualną ofertą wszystkie dostępne funkcje EMDR Online są bezpłatne."],
    },
    {
        q: "Co zrobić, jeśli nie mogę dołączyć do sesji?",
        a: [
            "W pierwszej kolejności należy:",
            "– sprawdzić, czy link został otwarty w aktualnej przeglądarce,",
            "– odświeżyć stronę,",
            "– zweryfikować połączenie z internetem,",
            "– ponownie otworzyć link przesłany przez terapeutę,",
            "– spróbować uruchomić sesję na innym urządzeniu lub w innej przeglądarce.",
            "Jeżeli problem nadal występuje, warto skontaktować się z terapeutą lub ze wsparciem technicznym EMDRlink.",
        ],
    },
];
